import { API_ROUTES } from "../constants/routes";
import axios from "axios";

export default class PROJECT_SERVICE {

  static all = async () => {
    try {
      const res = await axios.get(API_ROUTES.Project.ALL);
      return res?.data;
    } catch (error) {
      return error.response.data;
    }
  };

    static landingProjects = async () => {
        try {
            const res = await axios.get(API_ROUTES.Project.LANDING_PAGE_DATA);
            console.log(res)
            return res?.data;
        } catch (error) {
            return error.response.data;
        }
    };

  static create = async (data) => {
    try {
      const res = await axios.post(API_ROUTES.Project.CREATE, data);
      return res?.data;
    } catch (error) {
      return error.response.data;
    }
  };

  static destroy = async (id) => {
    try {
      const res = await axios.delete(API_ROUTES.Project.DELETE+id);
      return res?.data;
    } catch (error) {
      return error.response.data;
    }
  };

  static update = async (id, data) => {
    try {
      const res = await axios.put(API_ROUTES.Project.UPDATE+id, data);
      return res?.data;
    } catch (error) {
      return error.response.data;
    }
  };

}